    <nav class="bottom-nav">
      <a class="nav-item" [class.active]="isActive('/')"
         routerLink="/">
        <mat-icon>dashboard</mat-icon>
        <span>Главная</span>
      </a>
      <a class="nav-item" [class.active]="isActive('/cars')"
         routerLink="/cars">
        <mat-icon>directions_car</mat-icon>
        <span>Авто</span>
      </a>
      <a class="nav-item" [class.active]="isActive('/bookings')"
         routerLink="/bookings">
        <mat-icon>event_note</mat-icon>
        <span>Бронь</span>
      </a>
      <a class="nav-item" [class.active]="isActive('/rentals')"
         routerLink="/rentals">
        <mat-icon>car_rental</mat-icon>
        <span>Прокат</span>
      </a>
      <a class="nav-item" [class.active]="isActive('/clients')"
         routerLink="/clients">
        <mat-icon>person</mat-icon>
        <span>Клиенты</span>
      </a>
    </nav>
  
